<div id='app_comp'>
    <div *ngIf="showAppBar" id="nav-container">
        <app-nav-component></app-nav-component>
    </div>
    <div [ngClass]="{'router-div': showAppBar, 'router-div-without-appbar': !showAppBar}">
        <router-outlet *ngIf="!isIframe">

        </router-outlet>
        <app-snakbar-msg-display></app-snakbar-msg-display>
    </div>
</div>